/* src/app/components/identity/manage-password/manage-password-requirements/manage-password-requirements.component.scss */
:host-context(.dark-theme) .password-requirement-met {
  color: #ffc107;
}
.password-requirement-icon {
  font-size: 16px;
  height: 16px;
  width: 16px;
  vertical-align: middle;
}
.password-requirement-met {
  color: #3f51b5;
}
.password-requirement {
  margin: 4px 0;
}
/*# sourceMappingURL=manage-password-requirements.component.css.map */
